var _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPremiumMedicalDesktop = function SvgPremiumMedicalDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.166 21.435 37.104 16.21a3.115 3.115 0 0 0-2.25 0L21.79 21.435a3.014 3.014 0 0 0-1.889 2.814v5.003a32.153 32.153 0 0 0 13.062 25.783 5.044 5.044 0 0 0 2.974.964 5.044 5.044 0 0 0 3.055-.964 32.153 32.153 0 0 0 13.102-25.863v-5.004a3.014 3.014 0 0 0-1.929-2.733Zm-.12 7.817a30.144 30.144 0 0 1-12.279 24.235 3.014 3.014 0 0 1-3.577 0 30.143 30.143 0 0 1-12.278-24.235V24.25a1.005 1.005 0 0 1 .623-.945l13.062-5.225c.245-.1.519-.1.764 0l13.062 5.225a1.005 1.005 0 0 1 .622.945v5.003Z",
    fill: "url(#PremiumMedicalDesktop_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.022 29.92h-5.024v-5.025a1.005 1.005 0 0 0-1.004-1.004h-6.029a1.005 1.005 0 0 0-1.005 1.004v5.024h-5.024a1.005 1.005 0 0 0-1.004 1.005v6.029a1.005 1.005 0 0 0 1.004 1.004h5.024v5.024a1.005 1.005 0 0 0 1.005 1.005h6.029a1.005 1.005 0 0 0 1.004-1.005v-5.024h5.024a1.005 1.005 0 0 0 1.005-1.004v-6.029a1.005 1.005 0 0 0-1.005-1.005Zm-1.005 6.028h-5.023a1.004 1.004 0 0 0-1.005 1.005v5.023h-4.02v-5.023a1.005 1.005 0 0 0-1.004-1.005h-5.024v-4.02h5.024a1.005 1.005 0 0 0 1.005-1.004V25.9h4.019v5.024a1.005 1.005 0 0 0 1.005 1.005h5.023v4.019Z",
    fill: "url(#PremiumMedicalDesktop_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PremiumMedicalDesktop_svg__a",
    x1: 19.902,
    y1: 36,
    x2: 52.095,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "PremiumMedicalDesktop_svg__b",
    x1: 25.932,
    y1: 33.938,
    x2: 46.027,
    y2: 33.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })))));
};

export default SvgPremiumMedicalDesktop;